<h2 mat-dialog-title id="benefits-check-result-title" class="benefits-result__title">{{ view.title }}</h2>
<mat-dialog-content class="benefits-result" role="document">
  <mat-chip-list *ngIf="view.verdict as verdict" class="small-mat-chip" aria-label="Coverage result">
    <mat-chip [color]="verdict.color" selected>{{ verdict.label }}</mat-chip>
  </mat-chip-list>

  <p *ngIf="view.notice" class="benefits-result__notice">{{ view.notice }}</p>
  <p *ngIf="view.payerPlan" class="benefits-result__payer">{{ view.payerPlan }}</p>

  <section *ngFor="let group of view.groups" class="benefits-result__group">
    <h3 class="benefits-result__group-title">{{ group.title }}</h3>
    <dl class="benefits-result__lines">
      <ng-container *ngFor="let line of group.lines">
        <dt>{{ line.label }}</dt>
        <dd>{{ line.value }}</dd>
      </ng-container>
    </dl>
  </section>

  <p *ngIf="view.asOf" class="benefits-result__as-of">{{ view.asOf }}</p>
  <p class="benefits-result__message">{{ view.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="accent" mat-dialog-close>Close</button>
</mat-dialog-actions>
